import {
    FETCH_CATEGORIES,
    SET_ACTIVE_CATEGORY,
    SET_ACTIVE_LEAF_CATEGORY,
    SET_CATEGORIES_VISIBILITY,
    SET_IS_FETCHING_CATEGORIES,
} from 'reducers/actions-types';

import { findCategoryByProp } from './helpers';

/**
 * Convert the caregories to an object
 * @param {string} name - name of the category
 * @returns {{name: string, isActive: boolean}}
 */
function createCategory(category, level, parent) {
    if (category.children && category.children.length) {
        category.children = category.children.map(c => createCategory(c, level + 1, category));
    }

    return Object.assign({}, category, {
        parent,
        level,
    });
}

export default function categoriesReducer(state = {
    items: [],
    active: null,
    activeLeaf: null,
    isFetching: true,
    fetchingCategory: null,
    isCategorylistVisible: false,
}, { type, categories, category, isCategorylistVisible }) {
    let newCategories;
    let level;
    let parentNode;

    switch (type) {
        case SET_IS_FETCHING_CATEGORIES:
            return Object.assign({}, state, { fetchingCategory: category, isFetching: true });
        case SET_CATEGORIES_VISIBILITY:
            return Object.assign({}, state, { isCategorylistVisible });
        case FETCH_CATEGORIES:
            level = -1;

            if (typeof category === 'object') {
                level = category.level;
                parentNode = findCategoryByProp(state.items, category.id, 'id');
            }

            newCategories = categories.map(c => createCategory(
                c,
                // in case of direct link categories we need to handle the level differently
                // our application categories need three levels and the `direct_link` categories will skip the first level
                // this is a bit a hack and might be optimized in future avoiding a level based navigation
                c.is_direct_link ? 1 : level + 1,
                category,
            ));

            if (parentNode) {
                // Assign the new categories
                Object.assign(parentNode, { children: newCategories });

                // Reassign the items to trigger update
                return Object.assign({}, state, {
                    items: state.items.slice(),
                    isFetching: false,
                    fetchingCategory: null,
                });
            }

            return Object.assign({}, state, {
                isFetching: false,
                fetchingCategory: null,
                items: newCategories,
            });
        case SET_ACTIVE_CATEGORY:
        case SET_ACTIVE_LEAF_CATEGORY:
            return Object.assign({}, state, {
                [type === SET_ACTIVE_LEAF_CATEGORY ? 'activeLeaf' : 'active']: category ? Object.assign({}, category) : null,
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/categories/index.js